if (!customElements.get('subscription-popup')) {
  customElements.define(
    'subscription-popup',
    class SubscriptionPopup extends DrawerComponent {
      static get observedAttributes() {
        return super.observedAttributes.concat(['data-trigger-open', 'data-repeat-open']);
      }

      constructor() {
        super();
      }

      get requiresBodyAppended() {
        return false;
      }

      connectedCallback() {
        super.connectedCallback();

        this.addClassByUA()

        this.triggerOpen = this.dataset.triggerOpen;
        this.repeatOpen = this.dataset.repeatOpen;
        this.cookieName = 'sleektheme:popup';

        window.FoxTheme.DOMready(this.handleOpen.bind(this));

        window.FoxTheme.utils.addEventDelegate({
          context: this,
          selector: '.btn-apply-coupon-code',
          handler: async (e, target) => {
            e.preventDefault();
            const code = target.dataset.code;
            if (code) this.copyToClipboard(code, target);
          },
        });

        window.addEventListener('resize', () => {
          setTimeout(() => {
            this.addClassByUA()
          })
        })
      }

      addClassByUA() {
        if (window.FoxTheme.config.mqlMobile) {
          this.classList.add('drawer--bottom')
          this.classList.remove('modal')
        } else {
          this.classList.add('modal')
          this.classList.remove('drawer--bottom')
        }
      }

      prepareToShow() {
        super.prepareToShow();
        this.setRepeatOpen();
      }

      handleOpen() {
        if (Shopify.designMode) return;
        const subscriptionSuccessTip = this.querySelector('.subscription-popup__sub-success-tip')
        let savedData = FoxTheme.utils.getStorage(this.cookieName);
        if (savedData && savedData.opened && !subscriptionSuccessTip) {
          return false;
        }

        if (subscriptionSuccessTip) {
          const isSubmitted = localStorage.getItem('subscription-popup-posted_successfully') === 'true';
          if (isSubmitted) return
          const title = this.querySelector('.subscription-popup__title')
          const subText = this.querySelector('.subscription-popup__text')
          const cta = this.querySelector('.subscription-popup__cta')
          const code = this.querySelector('.subscription-popup__code')

          if (title) {
            title.style.display = 'none'
          }
          if (subText) {
            subText.style.display = 'none'
          }
          if (cta) {
            cta.style.display = 'none'
          }
          if (code) {
            code.style.display = 'none'
          }

          this.show()
          return;
        }

        switch (this.triggerOpen) {
          case 'delay':
            setTimeout(() => {
              this.show();
            }, 5000);
            break;
          case 'scroll_down':
            this.triggerAfterScroll(700, this.show.bind(this));
            break;
          default:
            this.show();
            break;
        }
      }

      triggerAfterScroll(offset = 500, trigger) {
        let opened = false;
        const start = 0;
        window.addEventListener('scroll', (e) => {
          let scrollTop =
            window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop;

          if (scrollTop - start > offset && !opened) {
            trigger();
            opened = true;
            return;
          }
        });
      }

      copyToClipboard(code, button) {
        navigator.clipboard.writeText(code);
        button.innerText = button.dataset.copiedText;
      }

      setRepeatOpen() {
        if (Shopify.designMode) return;

        let expires;
        switch (this.repeatOpen) {
          case 'no_repeat':
            expires = 365;
            break;
          case 'every_3_mins':
            expires = 3 / 60 / 24;
            break;
          case 'every_5_mins':
            expires = 5 / 60 / 24;
            break;
          case 'every_10_mins':
            expires = 1 / 6 / 24;
            break;
          case 'every_15_mins':
            expires = 15 / 60 / 24;
            break;
          case 'every_30_mins':
            expires = 1 / 2 / 24;
            break;
          case 'every_1_hr':
            expires = 1 / 24;
            break;
          case 'every_6_hrs':
            expires = 6 / 24;
            break;
          case 'every_12_hrs':
            expires = 1 / 2;
            break;
          case 'every_day':
            expires = 1;
            break;
          case 'every_3_days':
            expires = 3;
            break;
          case 'every_week':
            expires = 7;
            break;
          case 'every_2_weeks':
            expires = 14;
            break;
          case 'every_month':
            expires = 30;
            break;
          default:
            expires = 7;
            break;
        }

        window.FoxTheme.utils.setStorage(this.cookieName, { opened: true }, expires);
      }
    }
  );
}

if (!customElements.get('popup-tip')) {
  customElements.define(
    'popup-tip',
    class PopupTip extends DrawerComponent {
      constructor() {
        super();
        this.sectionId = this.dataset.sectionId
        this.init()
      }

      init() {
        const isSubmitted = localStorage.getItem('subscription-popup-posted_successfully') === 'true';
        if (!isSubmitted) {
          this.classList.remove('hidden')
        } else {
          return
        }
        if (this.sectionId) {
          this.subscriptionPopup = window.document.documentElement.querySelector('#SubscriptionModal-' + this.sectionId)
        }
        if (!this.subscriptionPopup) return
        this.addEventListener('click', function() {
          this.subscriptionPopup?.show()
          this.classList.add('hidden')
        })

        this.subscriptionPopup.addEventListener(this.subscriptionPopup.events.handleAfterHide, () => {
           this.classList.remove('hidden')
        })
      }
    })
}

if (!customElements.get('email-autocomplete')) {
    customElements.define(
    'email-autocomplete',
  class EmailAutocomplete extends HTMLElement {
      constructor() {
        super();
        this.suffixes = [
          'gmail.com', 'outlook.com', 'icloud.com', 'hotmail.com', 'yahoo.com','foxmail.com'
        ];
      }

      connectedCallback() {
        this.classList.add('newsletter-form-container');
        this.input = this.querySelector('input');
        this.clearBtn = this.querySelector('.input__clear'); // 获取清除按钮
        
        if (!this.input) return;

        this.initDatalist();
        this.input.setAttribute('list', this.datalistId);
        
        this.input.addEventListener('input', () => {
          this.handleInput();
          this.toggleClearBtn(); // 实时控制清除按钮显示
        });

        if (this.clearBtn) {
          this.clearBtn.addEventListener('click', () => this.clearInput());
        }
      }

      initDatalist() {
        this.datalistId = `email-list-${Math.random().toString(36).substring(2, 11)}`;
        const datalist = document.createElement('datalist');
        datalist.id = this.datalistId;
        this.appendChild(datalist);
        this.datalist = datalist;
      }

      handleInput() {
        const value = this.input.value;
        const atIndex = value.indexOf('@');
        this.datalist.innerHTML = ''; 

        if (atIndex > -1) {
          const prefix = value.substring(0, atIndex + 1);
          const currentSuffix = value.substring(atIndex + 1).toLowerCase();
          this.suffixes.forEach(suffix => {
            if (currentSuffix === '' || suffix.startsWith(currentSuffix)) {
              const option = document.createElement('option');
              option.value = prefix + suffix;
              this.datalist.appendChild(option);
            }
          });
        }
      }

      // --- 新增：清除逻辑 ---
      toggleClearBtn() {
        if (this.clearBtn) {
          this.clearBtn.style.display = this.input.value.length > 0 ? 'block' : 'none';
        }
      }

      clearInput() {
        this.input.value = '';
        this.toggleClearBtn();
        this.datalist.innerHTML = '';
        this.input.focus();
      }
    }
  )
}